import { render, staticRenderFns } from "./Home_B_Plus.vue?vue&type=template&id=2034f9d8&"
import script from "./Home_B_Plus.vue?vue&type=script&lang=js&"
export * from "./Home_B_Plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports